<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nº Guia</th>
          <th>Paciente</th>
          <th>Convênio</th>
          <th>Especialidade</th>
          <th>Unidade</th>
          <th>Data da Guia</th>
          <th>Data Faturamento</th>
          <th>Total Pago</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="linha in linhas" :key="linha.numero_guia">
          <td>{{ linha.numero_guia }}</td>
          <td>{{ linha.paciente }}</td>
          <td>{{ linha.convenio }}</td>
          <td>{{ linha.especialidade }}</td>
          <td>{{ linha.unidade }}</td>
          <td>{{ linha.data_criacao_guia }}</td>
          <td>{{ linha.data_faturamento }}</td>
          <td>{{ linha.total_pago }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'GuiasNaoFaturadasTabela',
  props: {
    linhas: {
      type: Array,
      required: true,
    },
  },
}
</script>
